import { useSelector } from 'react-redux';

import { getIsBookingForSelf, getIsInstantTaxCreditSelected } from '@front/common/src/ducks/customer/basket-selectors';
import type { User } from '@front/common/src/types/commons';

export type UseIsITCSelectedOrSuccessfullyPairedParams = {
  user?: User;
};

export const useIsITCSelectedOrSuccessfullyPaired = ({ user }: UseIsITCSelectedOrSuccessfullyPairedParams) => {
  // if isInstantTaxCreditSelected is undefined, we set it to false
  const isInstantTaxCreditSelected = useSelector(getIsInstantTaxCreditSelected) ?? false;
  const isBookingForSelf = useSelector(getIsBookingForSelf);

  const isWecasaCarePairingSuccessful = user?.wecasa_care_pairing_status === 'successful';
  // isBookingForSelf is undefined when customer screen is skipped during account creation — treat as for self
  const shouldShowTaxCreditPriceInfo = isBookingForSelf === undefined || isBookingForSelf;
  const isITCSelectedOrSuccessfullyPaired =
    shouldShowTaxCreditPriceInfo && (isWecasaCarePairingSuccessful || isInstantTaxCreditSelected);

  return {
    isInstantTaxCreditSelected,
    isWecasaCarePairingSuccessful,
    isITCSelectedOrSuccessfullyPaired,
    shouldShowTaxCreditPriceInfo,
  };
};
